export default {
    parts: [],
    baseStyle: (props) => {
        // Helper function to check if side title is enabled for a breakpoint
        const isSideTitle = {
            mobile: props?.CarouselTitleDisplayStyleMobile === 'Side Title',
            tablet: props?.CarouselTitleDisplayStyleTablet === 'Side Title',
            desktop: props?.CarouselTitleDisplayStyleDesktop === 'Side Title'
        }

        // Helper function to get alignment styles for a breakpoint
        const getAlignmentStyles = (breakpoint) => {
            const alignment = props?.Alignment || 'top/left'
            const [vertical, horizontal] = alignment.split('/')

            return {
                textAlign:
                    horizontal === 'center' ? 'center' : horizontal === 'right' ? 'right' : 'left',
                justifyContent:
                    vertical === 'center' ? 'center' : vertical === 'bottom' ? 'end' : 'start'
            }
        }

        return {
            container: {
                // No padding here - carousel bleeds to edges
                // Title padding is handled in titleWrapper
            },
            wrapper: {
                marginTop: {base: 6, lg: 8},
                marginBottom: {base: 6, lg: 8},
                // Set flex layout when any breakpoint has side title
                display: {
                    base: isSideTitle.mobile ? 'flex' : 'block',
                    md: isSideTitle.tablet ? 'flex' : 'block',
                    lg: isSideTitle.desktop ? 'flex' : 'block'
                },
                gap: 2,
                flexWrap: 'nowrap'
            },

            sliderWrapper: {
                minWidth: 0,
                // Add padding when carousel doesn't bleed (all items fit)
                paddingLeft: {
                    base: props?.shouldBleedMobile ? 0 : 4,
                    md: props?.shouldBleedTablet ? 0 : 4,
                    lg: props?.shouldBleedDesktop ? 0 : 6
                },
                paddingRight: {
                    base: props?.shouldBleedMobile ? 0 : 4,
                    md: props?.shouldBleedTablet ? 0 : 4,
                    lg: props?.shouldBleedDesktop ? 0 : 6
                }
            },

            titleWrapper: {
                minWidth: 0,
                width: '100%',
                // Padding for title alignment with page content
                // Only add padding when container is full viewport (no existing container padding)
                paddingLeft: {
                    base: props?.isAlreadyFullViewport ? 4 : 0,
                    lg: props?.isAlreadyFullViewport ? 6 : 0
                },
                paddingRight: {
                    base: props?.isAlreadyFullViewport ? 4 : 0,
                    lg: props?.isAlreadyFullViewport ? 6 : 0
                },

                // Apply side title styles when enabled
                ...(isSideTitle.mobile && {
                    maxWidth: {
                        base: '342px',
                        md: isSideTitle.tablet ? '120px' : 'none',
                        lg: isSideTitle.desktop ? '342px' : 'none'
                    },
                    display: {
                        base: 'flex',
                        md: isSideTitle.tablet ? 'flex' : 'block',
                        lg: isSideTitle.desktop ? 'flex' : 'block'
                    },
                    flexDirection: {base: 'column'},
                    ...getAlignmentStyles('mobile')
                }),

                ...(isSideTitle.tablet &&
                    !isSideTitle.mobile && {
                        maxWidth: {
                            base: 'none',
                            md: '120px',
                            lg: isSideTitle.desktop ? '342px' : 'none'
                        },
                        display: {
                            base: 'block',
                            md: 'flex',
                            lg: isSideTitle.desktop ? 'flex' : 'block'
                        },
                        flexDirection: {base: 'row', md: 'column'},
                        ...{
                            textAlign: {base: 'left', md: getAlignmentStyles('tablet').textAlign},
                            justifyContent: {
                                base: 'start',
                                md: getAlignmentStyles('tablet').justifyContent
                            }
                        }
                    }),

                ...(isSideTitle.desktop &&
                    !isSideTitle.mobile &&
                    !isSideTitle.tablet && {
                        maxWidth: {base: 'none', md: 'none', lg: '342px'},
                        display: {base: 'block', md: 'block', lg: 'flex'},
                        flexDirection: {base: 'row', md: 'row', lg: 'column'},
                        ...{
                            textAlign: {
                                base: 'left',
                                md: 'left',
                                lg: getAlignmentStyles('desktop').textAlign
                            },
                            justifyContent: {
                                base: 'start',
                                md: 'start',
                                lg: getAlignmentStyles('desktop').justifyContent
                            }
                        }
                    })
            },

            swiperCustom: {
                '& .swiper-button-disabled': {
                    display: 'none'
                },
                '& .swiper-button-lock': {
                    display: 'none'
                },
                // Hide prev button on initial load - show only after Swiper initializes
                // When Swiper initializes, it adds swiper-button-disabled or swiper-button-lock classes
                // So we hide prev buttons that don't have either class (not yet initialized)
                '& .custom-swiper-prev:not(.swiper-button-disabled):not(.swiper-button-lock)': {
                    display: 'none'
                }
            },

            title: {
                fontSize: {base: 'xl', lg: '32px'},
                lineHeight: {base: '100%', lg: '34px'},

                // Simple margin logic: add margins only when NOT using side title
                marginTop: {
                    base: !isSideTitle.mobile ? 6 : 0,
                    md: !isSideTitle.tablet ? 8 : 0,
                    lg: !isSideTitle.desktop ? 8 : 0
                },
                marginBottom: {
                    base: !isSideTitle.mobile ? 3 : 0,
                    md: !isSideTitle.tablet ? 4 : 0,
                    lg: !isSideTitle.desktop ? 4 : 0
                }
            },

            swiperNav: {
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
                backgroundColor: 'white',
                cursor: 'pointer',
                width: '32px',
                height: '32px',
                background: '#FFFFFF80'
            }
        }
    }
}
